import { render, staticRenderFns } from "./DocumentHistory.vue?vue&type=template&id=1962b332&scoped=true"
import script from "./DocumentHistory.vue?vue&type=script&lang=js"
export * from "./DocumentHistory.vue?vue&type=script&lang=js"
import style0 from "./DocumentHistory.vue?vue&type=style&index=0&id=1962b332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1962b332",
  null
  
)

export default component.exports